import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CookiePopup = ({lang, translations}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem("cookiesAccepted");
    if (!cookiesAccepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookiesAccepted", "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-popup">
      <div className="cookie-content">
        <p>
          {translations[lang].cookiespopup1}{" "}
          <Link to={`/politica-de-cookies?lang=${lang}` }>
            {translations[lang].cookiespopup2}
          </Link>
        </p>

        <div className="cookie-buttons">
          <button className="button1" onClick={acceptCookies}>
            {translations[lang].acceptcookies}
          </button>
          <button className="button1" onClick={rejectCookies}>
            {translations[lang].rejectcookies}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiePopup;
